const theme = {
  '--gray-color': '#F8E1F4',
  '--orange-color': '#a10058',
  '--orange-hover-color': '#FF69B4',
  '--orange-datepicker-selection-color': '#E0218A',
  '--blue-color': '#E0218A',
  '--white-color': '#FFFFFF',
  '--black-color': '#000000',
  '--navtext-color': '#FFFFFF',
  '--header-color': '#E0218A',
};

export default theme;